<template>
  <div class="Wizard">
    <ProjectDetails v-if="currentStep === 'project'" />

    <!-- platform-specific: express -->
    <Auth v-if="currentStep === 'auth'" />
    <Models v-if="currentStep === 'models'" />
    <ModelDetail
      v-if="currentStep.startsWith('models/')"
      :key="currentStep"
    />

    <Api v-if="currentStep === 'api'" />
    <DevOps v-if="currentStep === 'devops'" />

    <Generate v-if="!isDemo && currentStep === 'generate'" />
    <FinishDemo v-if="isDemo && currentStep === 'generate'" />
  </div>
</template>

<style lang="scss" scoped>
.Wizard {
  flex: 1;
}
</style>

<script>
import { mapState } from 'vuex';

import { isDemo } from '../utils/config';

import Auth from './Auth.vue';
import ProjectDetails from './ProjectDetails.vue';
import Models from './Models.vue';
import ModelDetail from './ModelDetail.vue';
import Api from './Api.vue';
import DevOps from './DevOps.vue';
import Generate from './Generate.vue';
import FinishDemo from './FinishDemo.vue';

export default {
  name: 'Wizard',
  components: {
    Auth,
    ProjectDetails,
    Models,
    ModelDetail,
    Api,
    DevOps,
    Generate,
    FinishDemo,
  },
  computed: {
    ...mapState(['currentStep']),
    isDemo: () => isDemo,
  },
};
</script>
